import { useRef } from "react";
import { DragDropProvider } from "@dnd-kit/react";
import { pointer, isPointerOutsideWindow, windowAutoScrollPlugins } from "./TaskGroupViews";
import { NestDepoContext, NestDropContext, useNestDnd } from "../lib/nestDrop";

// AŞAMA 11 — dışarı alınmış GÖREV penceresi içindeki alt görev ağacı için
// kendi sürükleme sağlayıcısı. Pencere İÇİNDE bırakma = sıralama, pencerenin
// DIŞINA bırakma = alt görevi kendi yüzen penceresine çıkarma (her seviyede).
// AŞAMA 12 — pencere içinde de "＋İÇİNE" noktası çalışır (ana listeyle aynı
// kurallar); nokta hedefse sıralama önizlemesi uygulanmaz.
export const DetachedTaskCardDnd = ({
  onSubtaskDrag, onDetachSubtask, children,
  onDropIntoTask, invalidDropIdsFor, dragCountOf, kapsam = "pencere",
}) => {
  const kokRef = useRef(null);
  const { nest, depo, baslat, uzerinde, bitir } = useNestDnd({
    invalidDropIdsFor, dragCountOf, onDropIntoTask, kapsam,
  });
  return (
    <div ref={kokRef} data-testid="detached-task-dnd-root">
      <DragDropProvider
        plugins={windowAutoScrollPlugins}
        onDragStart={baslat}
        onDragOver={(event, manager) => {
          if (uzerinde(event, manager)) return;
          onSubtaskDrag(event, true);
        }}
        onDragEnd={(event, manager) => {
          const hedef = bitir(event, manager);
          const src = event?.operation?.source;
          if (hedef) {
            // yerel sıralama önizlemesini geri al, sonra taşımayı uygula
            onSubtaskDrag(event, false, true);
            onDropIntoTask(hedef, { id: src?.id, data: src?.data || {} });
            return;
          }
          if (
            !event?.canceled &&
            src?.data?.kind === "subtask" &&
            isPointerOutsideWindow(kokRef.current)
          ) {
            onSubtaskDrag(event, false, true);
            onDetachSubtask(src.id, { x: pointer.x, y: pointer.y });
            return;
          }
          onSubtaskDrag(event, false, !!event?.canceled);
        }}
      >
        <NestDepoContext.Provider value={depo}>
          <NestDropContext.Provider value={nest}>{children}</NestDropContext.Provider>
        </NestDepoContext.Provider>
      </DragDropProvider>
    </div>
  );
};

export default DetachedTaskCardDnd;
